import { render, staticRenderFns } from "./InicioCaja.vue?vue&type=template&id=1b8cab90"
import script from "./InicioCaja.vue?vue&type=script&lang=js"
export * from "./InicioCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports